import { render, staticRenderFns } from "./PrintOrdersPageContainer.vue?vue&type=template&id=0ea737bc&"
import script from "./PrintOrdersPageContainer.vue?vue&type=script&lang=js&"
export * from "./PrintOrdersPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports